module.exports = __webpack_public_path__ + "static/media/oberflex-cheneardoiset308-1200x2490.f8622885.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-cheneardoiset308-1200x2490.jpg
// module id = 996
// module chunks = 37